'use client';

import { useTranslations } from 'next-intl';

const WidgetStepsNotFound = () => {
  const t = useTranslations('Widget.pages.errors.notFound');
  return (
    <main className='flex h-full flex-col items-center justify-center p-4'>
      <h1 className='text-center vp-title-s mb-2'>{t('title')}</h1>
      <h2 className='text-center vp-body-m'>{t('description')}</h2>
    </main>
  );
};

export default WidgetStepsNotFound;
